export default __webpack_public_path__ + "static/media/sampleQbInvoiceFile.e641ae4d.xlsx";